import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { LangProvider } from "@/lib/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import SessionForm from "@/pages/SessionForm";
import Garage from "@/pages/Garage";
import TelemetryCompare from "@/pages/TelemetryCompare";
import Pressures from "@/pages/Pressures";
import TyreArchive from "@/pages/TyreArchive";
import TyreSetDetail from "@/pages/TyreSetDetail";
import Settings from "@/pages/Settings";
import Drivers from "@/pages/Drivers";
import Tracks from "@/pages/Tracks";
import Weather from "@/pages/Weather";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/events" replace />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:eventId" element={<EventDetail />} />
        <Route path="/events/:eventId/sessions/new" element={<SessionForm />} />
        <Route path="/events/:eventId/sessions/:sessionId" element={<SessionForm />} />
        <Route path="/garage" element={<Garage />} />
        <Route path="/telemetry" element={<TelemetryCompare />} />
        <Route path="/pressures" element={<Pressures />} />
        <Route path="/tyres" element={<TyreArchive />} />
        <Route path="/tyres/:setId" element={<TyreSetDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/drivers" element={<Drivers />} />
        <Route path="/tracks" element={<Tracks />} />
        <Route path="/weather" element={<Weather />} />
      </Route>
      <Route path="*" element={<Navigate to="/events" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster theme="dark" position="bottom-right" richColors />
        </SettingsProvider>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
